import { Button, ButtonMode, Modal, ModalWidth } from '@creditsights/styleguide-web';
import Pluralize from 'react-pluralize';
import React, { useState } from 'react';
import { useGlobalModalContext } from '../../../../components/GlobalModal';
import useModalErrorHandler from '../../../../hooks/modal/useModalErrorHandler';

interface ConfirmDeleteSearchesModalProps {
  onConfirm: () => void;
  selectedSearchesCount: number;
}

const ConfirmDeleteSearchesModal = ({
  selectedSearchesCount,
  onConfirm,
}: ConfirmDeleteSearchesModalProps): React.ReactElement => {
  const { closeModal, setError, store } = useGlobalModalContext();
  const [isDeleting, setIsDeleting] = useState(false);
  const isModalCloseable = !isDeleting;
  useModalErrorHandler(setIsDeleting);

  const renderFooter = () => (
    <>
      <Button
        disabled={isDeleting}
        dataTestId="delete-searches-cancel-button"
        onClick={closeModal}
        mode={ButtonMode.SECONDARY}
      >
        Cancel
      </Button>
      <Button
        disabled={isDeleting}
        loading={isDeleting}
        onClick={() => {
          setIsDeleting(true);
          setError('');
          onConfirm();
        }}
        dataTestId="delete-searches-confirm-button"
        mode={ButtonMode.PRIMARY}
      >
        Delete
      </Button>
    </>
  );

  return (
    <Modal
      width={ModalWidth.Small}
      closeOnEscape={isModalCloseable}
      closeOnDimmerClick={isModalCloseable}
      open
      onClose={closeModal}
      headerTitle={
        <>
          Delete Saved <Pluralize count={selectedSearchesCount} singular="Search" plural="Searches" showCount={false} />
        </>
      }
      footer={renderFooter()}
      error={store.props.error}
      dataTestId="confirm-delete-searches-modal"
      closeOnButtonClick={isModalCloseable}
    >
      <p>
        Are you sure you want to delete the selected saved{' '}
        <Pluralize count={selectedSearchesCount} singular="search" plural="searches" showCount={false} />?
      </p>
    </Modal>
  );
};

export default ConfirmDeleteSearchesModal;
